import { supabase } from "@/integrations/supabase/client";
import { QueryData } from "@supabase/supabase-js";

// Query-funktio, jota käytetään sekä tyypitykseen että hakuun
export const getOrderDetailQuery = (orderId: string) =>
  supabase
    .from("orders")
    .select(`
      *,
      customers (*),
      cemeteries (*),
      partners (*),
      order_lines (
        *,
        products (id, name, sku),
        configurations (
          id,
          name,
          product_models (id, name, is_custom_template),
      config_components (
            id,
            quantity,
            width,
            height,
            thickness,
            source_model_name,
            materials (id, name),
            model_components (
              id,
              position,
              component_types (id, name)
            )
          )
        )
      ),
      order_proofs!order_proofs_order_id_fkey (*),
      order_files (*),
      order_materials (
        *,
        materials (id, name, sku, category)
      ),
      installations (*)
    `)
    .eq("id", orderId)
    .is("deleted_at", null)
    .single();

// Tyyppi päätellään automaattisesti kyselystä
export type OrderDetailData = QueryData<ReturnType<typeof getOrderDetailQuery>>;

// Apuinterface work_details -kentälle
export interface WorkDetails {
  name?: string;
  birth_date?: string;
  death_date?: string;
  font?: string;
  engraving_style?: string;
  text_size?: string;
  additional_text?: string;
  ornament?: string;
  stone_description?: string;
  notes?: string;
}

// ============ ORDERS LIST TYPES ============

// Filters-objekti
export interface OrderFilters {
  search: string;
  status: string;
  orderType: string;
  approval: string;
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
}

export const DEFAULT_ORDER_FILTERS: OrderFilters = {
  search: "",
  status: "all",
  orderType: "all",
  approval: "all",
  dateFrom: undefined,
  dateTo: undefined,
};

// Tab-tyyppi
export type OrderTabType = "active" | "archive" | "deleted";

// Lista-näkymän tilausrivi
export interface OrderLineItem {
  id: string;
  description: string;
  quantity: number;
  unit_price: number;
  line_total: number;
  work_details?: WorkDetails | null;
  configuration_id?: string | null;
  configurations?: {
    id: string;
    name: string | null;
    product_models: {
      id: string;
      name: string;
      is_custom_template: boolean | null;
    } | null;
    config_components?: {
      id: string;
      quantity: number;
      width: number | null;
      height: number | null;
      thickness: number | null;
      source_model_name: string | null;
      materials: { id: string; name: string } | null;
      model_components: {
        id: string;
        position: number;
        component_types: { id: string; name: string } | null;
      } | null;
    }[];
  } | null;
}

// Lista-näkymän materiaali
export interface OrderMaterialItem {
  id: string;
  quantity: number;
  width: number;
  length: number;
  thickness: number;
  materials: { name: string } | null;
}

// Lista-näkymän tilaustyyppi
export interface OrderListItem {
  id: string;
  order_number: string;
  order_date: string;
  order_type: string;
  fulfillment_type: string;
  status: string;
  total_amount: number;
  notes: string | null;
  tracking_token: string | null;
  deleted_at: string | null;
  requires_cemetery_approval: boolean | null;
  cemetery_approval_status: string | null;
  customers: {
    id: string;
    first_name: string | null;
    last_name: string | null;
    company_name: string | null;
    phone: string | null;
    email: string | null;
  } | null;
  cemeteries: { id: string; name: string; city: string } | null;
  partners: { id: string; name: string } | null;
  order_lines: OrderLineItem[];
  order_proofs: { id: string; status: string }[] | null;
  order_materials: OrderMaterialItem[];
}
